import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { PatientIdentifiers, Profile } from './Profile.model';
import { fetchPatientIdentifiers, fetchProfile } from './Profile.thunk';
import {
  convertPatientIdentifiersResponse,
  convertProfileResponse,
} from './Profile.factory';

export const ProfileAdapter = createEntityAdapter<Profile>({
  selectId: (profile) => profile.id,
  sortComparer: (a, b) => (a.id < b.id ? -1 : 1),
});

const ProfileSlice = createSlice({
  name: 'profiles',
  initialState: ProfileAdapter.getInitialState({
    identifiers: {} as Record<string, PatientIdentifiers>,
  }),
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fetchProfile.fulfilled, (state, action) => {
        ProfileAdapter.upsertOne(
          state,
          convertProfileResponse(
            action.payload.profile,
            action.payload.community,
            action.payload.interest_tags,
            action.payload.primary_diagnoses,
          ),
        );
      })
      .addCase(fetchPatientIdentifiers.fulfilled, (state, action) => {
        return {
          ...state,
          identifiers: {
            ...state.identifiers,
            [action.meta.arg.userId]: convertPatientIdentifiersResponse(
              action.payload,
            ),
          },
        };
      }),
});

export default {
  reducers: ProfileSlice.reducer,
  adapter: ProfileAdapter,
};
